import { render } from "./CollectionCardHeader.vue?vue&type=template&id=1d9d0957"
import script from "./CollectionCardHeader.vue?vue&type=script&lang=js"
export * from "./CollectionCardHeader.vue?vue&type=script&lang=js"

import "./CollectionCardHeader.vue?vue&type=style&index=0&id=1d9d0957&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__